export const API_LOGIN = '/login';
export const API_FORGET_PASS = '/forgotPassword';
export const API_CHANGE_PASSWORD = '/changePassword';
export const API_SEARCH_USER = '/search-user';

export const API_HOME = '/home';
export const API_GET_MENU = '/common/menu';
export const API_GET_ME = '/me';
export const API_ONLINE_CHECK = '/common/onlineCheck';

export const API_SEARCH_LIST_KOJO_HIMMOKU = '/common/listKojoHimmoku';
export const API_SEARCH_MITSUMORI_HIMMOKU = '/gcommon/listMitsumoriHimmoku';

export const API_SEARCH_G_SHUKASAKI_SOKO = '/gCommon/shukasakiSoko';
export const API_SEARCH_JIGYOSHO = '/gCommon/jigyoshoMst';
export const API_SEARCH_CHUBUNRUI = '/common/chubunruiMst';
export const API_SEARCH_SHIIRESAKI = '/gCommon/shiiresakiMst';
export const API_SEARCH_DAIBUNRUI = '/common/daibunruiMst';
export const API_SEARCH_SOKO = '/gCommon/sokoMst';
export const API_SEARCH_HIMMOKU = '/gCommon/himmoku';
export const API_SEARCH_JYKO = '/common/jikoMst';
export const API_SEARCH_SHOGTEKIYO = '/common/shogTekiyoMst';
export const API_SEARCH_SHUKA_AREA = '/common/shukaAreaMst';
export const API_SEARCH_HAISO_AREA = '/common/haisoAreaMst';
export const API_SEARCH_TOKUISAKI = '/gCommon/tokuisakiMst';
export const API_SEARCH_ZAIKO = '/common/listzaiko';
export const API_SEARCH_MENU_ADDRESS = '/common/menuAddressMst';
export const API_SEARCH_SHUKA_AREA_HIMMOKU = '/common/listShukaAreaHimmoku';
export const API_SEARCH_NOHINSAKI = '/gCommon/nohinsakiMst';
export const API_SEARCH_SHUKASAKI_SOKO = '/common/shukasakiSoko';
export const API_SEARCH_JIGYOSHO_GINKO = '/common/jigyoshoGinkoMst';
export const API_SEARCH_KANRI_HIMMOKU = '/common/kanriHimmokuMst';
export const API_SEARCH_MEISHO = '/common/meishoMst';
export const API_SEARCH_ITAKUSAKI = '/gCommon/itakusakiMst';
export const API_GET_SHIIRE_TANKA = '/common/shiireTanka';

export const API_SEARCH_HATCHU_ENTRY = '/hatchuEntry';
export const API_GET_JIGYOSHO_STATE = '/common/online';

export const API_GET_SELECT_ORDER_NO = '/common/orderNo';
export const API_GET_SELECT_ORDER_CODE = '/common/orderEijiList';
export const API_GET_MITSUMORI_TANKA = '/gCommon/mitsumoriTanka';
export const API_GET_SOSHIKI_MST = '/common/soshikiMst';
export const API_GET_MENU_PTN = '/common/menuPtn';

export const API_GET_NENDO = '/common/nendo';
export const API_GET_ZAIKO_INFO = '/common/zaikoInfo';
export const API_GET_WARIATE_INFO = '/common/wariateInfo';
export const API_GET_MEISHO_MST = '/gCommon/meishoMst';
export const API_GET_GYOSHU_MST = '/gCommon/gyoshuMst';
export const API_GET_SHUKASAKI_SOKO = '/gCommon/shukasakiSoko';
export const API_GET_UCHIWAKE_CALC = '/common/uchiwakeCalc';
export const API_GET_SHOHIZEI_MST = '/common/shohizeiMst';
export const API_SAITO_CALC = '/common/saitoCalc';
export const API_SHOHIZEI_CALC = '/common/shohizeiCalc';
export const API_GET_SYSDATE = '/common/sysdate';
export const API_EIGYO_YMD_CHECK = '/common/eigyoYmdCheck';
export const API_GET_BESSHI_TEMP = '/gCommon/besshiTemp';
export const API_GET_SYSTEM_DATETIME = '/gCommon/systemDateTime';

export const API_UPLOAD_FILE = '/uploadFile';
export const API_UPLOAD_FILE_2 = '/uploadFile2';
export const API_DOWNLOAD_FILE = '/downloadFile';
export const API_G_DOWNLOAD_FILE = '/gDownloadFile';
export const API_DELETE_FILE = '/deleteFile'; // #886227

export const API_N_060SHI_JUCHU_KAKUTEI = '/juchuKakutei';

export const API_N_010JUC_GET = '/N_010juc/N_Juc020_JuchuEntry/slipList';
export const API_N_010JUC_SLIP = '/N_010juc/N_Juc020_JuchuEntry/slip';
export const API_N_040JUC = '/juchuList';

export const API_N_030URI_URIAGE_LIST = '/uriageList';
export const API_N_030URI_URIAGE_LIST_MI = '/uriageList/mi';

// export const API_N_100SEI_GET = '/N_100sei/N_Sei010_SeikyuShukei/cancel';
// export const API_N_100SEI_POST = '/N_100sei/N_Sei010_SeikyuShukei/total';
// export const API_N_100SEI_PUT = '/N_100sei/N_Sei010_SeikyuShukei/cancel';
// export const API_N_100SEI_SLIP = '/N_100sei/N_Sei010_SeikyuShukei/slip';

export const API_N_100SEI_GET = '/seikyutotal/cancel';
export const API_N_100SEI_POST = '/seikyutotal/total';
export const API_N_100SEI_PUT = '/seikyutotal/cancel';

export const API_N_100SEI_SEIKYUSHO_GET = '/SeikyuSho/seikyuGet';
export const API_N_100SEI_SEIKYUSHO_RESET = '/SeikyuSho/seikyuReset';

export const API_N_010SHU_JUNBI = '/shukkaJunbi/junbi';
export const API_N_010SHU_JUNBI_CSV = '/shukkaJunbi/junbiCsv';
export const API_N_010SHU_IKKATSU = '/shukkaJunbi/ikkatsu';
export const API_N_010SHU_HIKIATE = '/shukkaJunbi/hikiate';
export const API_N_010SHU_KAIJO = '/shukkaJunbi/kaijo';
export const API_N_010SHU_HIKIATE_GET = '/shukkaJunbi/hikiateGet';

export const API_N_100SEI_HAISO_INFO_GET = '/utils/haisoInfo';
export const API_N_100SEI_SEIKYU_SAN_SHO = '/SeikyuSanSho';
export const API_N_010JUC = '/juchuEntry';
export const API_N_MAS010_MASTER_SHONIN = '/masterShonin';
export const API_N_MAS150_IKAN_TANKA_MST_MENTE = '/ikanTankaMstMente';

export const API_N_130MAS_LIST =
  '/N_130mas/N_Mas040_HimmokuDaibunruiMstMente/list';
export const API_N_130MAS_DATA =
  '/N_130mas/N_Mas040_HimmokuDaibunruiMstMente/data';

export const API_N_190MEI_MEISHOMST =
  '/N_010juc/N_Mas190_MeishoMstMente/meishoMst';

export const API_N_170MAS_MENUPATTERN =
  '/N_130mas/N_Mas170_MenuPatternMstMente/menuPatternMst';

export const API_N_010KAK_KAKO_FURIKAE = '/kakoFurikaeEntry';
export const API_N_NIJ030_HEIKYOKU_SHORI = '/heikyokuShori';
export const API_N_NIJ020_KAIKYOKU_SHORI = '/kaikyokuShori';
export const API_N_NIJ040_TORIHIKI_SHONIN = '/torihikiShonin';
export const API_N_NIJ100_TORIHIKI_SHONIN = '/torihikiShonin2';

export const API_N_NIJ060_KEIJO_LIST = '/keijoList';
export const API_N_010HAT = '/hatchuIraiEntry';
export const API_N_SHI010_SHIIRE_ENTRY = '/shiireEntry';
export const API_N_020HAT_DATASEISEI = '/hatchuDataSeisei';
export const API_N_040HAT_HATCHU_KAKUTEI = '/hatchuKakutei';
export const API_N_050HAT = '/hatchuSend';
export const API_N_HAT070_HASSO_JISSEKI_UPD = '/hassoJissekiUpd';
export const API_N_080HAT_HASSOANNAI = '/hassoAnnaiEntry';

export const API_N_010SHO_SHOGAKARI_ENTRY = '/shogakariEntry';

export const API_N_010ZAI = '/zaikoIdoIraiEntry';
export const API_N_020ZAI = '/zaikoShokai';
export const API_N_030ZAI = '/NyushukkoList';

export const API_N_MAS030_HIMMOKU_MST_MENTE = '/himmokuMstMente';
export const API_N_MAS040_HIMMOKU_DAIBUNRUI_MST_MENTE =
  '/himmokuDaibunruiMstMente';
export const API_N_MAS050_HIMMOKU_CHUBUNRUI_MST_MENTE =
  '/himmokuChubunruiMstMente';
export const API_N_MAS060_RIYOSHA_MST_MENTE = '/riyoshaMstMente';
export const API_N_MAS090_SHIIRESAKI_MST_MENTE = '/shiiresakiMstMente';
export const API_N_MAS070_TOKUISAKI_MST_MENTE = '/tokuisakiMstMente';
export const API_N_MAS080_NOHINSAKI_MST_MENTE = '/nohinsakiMstMente';
export const API_N_MAS120_SOKO_MST_MENTE = '/sokoMstMente';
export const API_N_MAS130_MITSUMORI_TANKA_MST_MENTE = '/mitsumoriTankaMstMente';
export const API_N_MAS140_SHIIRE_TANKA_MST_MENTE = '/shiireTankaMstMente';
export const API_N_MAS190_UNCHIN_KEISAN_MST_MENTE = '/unchinKeisanMstMente';

export const API_N_URI030_NOHINSHO_SEND = '/nohinshoSend';
export const API_N_SHU050_SHUKKA_JISSEKI_UDP = '/shukkaJissekiUpd';
export const API_N_URI020_URIAGE_IKKATSU_KEIJO = '/uriageIkkatsuKeijo';
export const API_N_URI010_URIAGE_ENTRY = '/uriageEntry';
export const API_N_SHI020_SHIIRE_IKKATSU_KEIJO = '/shiireIkkatsuKeijo';
export const API_N_MAS250_OSHIRASE_MST_MENTE = '/oshiraseMstMente';
export const API_N_SHU020_SHUKKAKAKUTEI = '/shukkaKakutei';
export const API_N_SHU030_HAISOIRAISEND = '/haisoIraiSend';
export const API_N_SHU060_SHUKKAANNAISEND = '/shukkaAnnaiSend';

export const API_N_SEI040_SEIKYU_LIST = '/SeikyuList';
export const API_N_NYU040_NYUKO_JISSEKI_UDP = '/nyukoJissekiUpd';

export const API_N_NIJ080_KAKUTEIGEMBO = '/kakuteiGembo';

export const API_N_SHI050 = '/shiireList';
export const API_G_020_JUCHU_ENTRY = '/gJuchuEntry';
export const API_G_030_JUCHU_TOIAWASE = '/gJuchuToiawase';
export const API_G_040_HATCHU_CONFIRM = '/gHatchuConfirm';
export const API_G_050_HASSO_ANNAI_ENTRY = '/gHassoAnnaiEntry';
export const API_G_060_SHUKKA_JUNBI = '/gShukkaJunbi';
export const API_G_070_HAMBAI_YOSOKU_CONFIRM = '/gHambaiYosokuConfirm';
export const API_G_080_KOJO_DEKIDAKA_ENTRY = '/gKojoDekidakaEntry';
export const API_G_090_ZAIKO_IDO_IRAI_ENTRY = '/gZaikoIdoIraiEntry';
export const API_G_110_SEIKYU_LIST = '/gSeikyuList';
export const API_G_130_NOHINSAKI_MST_MENTE = '/gNohinsakiMstMente';
export const API_G_140_HAISO_IRAI = '/gHaisoIrai';
export const API_G_150_HAISO_MST_MENTE = '/gHaisoMstMente';
export const API_G_160_HAISO_IRAI_LOGI = '/gHaisoIraiLogi';

export const STATUS_CODE = {
  CONTINUE: 100,
  SWITCHING_PROTOCOL: 101,
  PROCESSING: 102,
  EARLY_HINTS: 103,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTI_STATUS: 207,
  ALREADY_REPORTED: 208,
  IM_USED: 226,
  MULTIPLE_CHOICE: 300,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYP: 415,
  RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  AUTHENTICATION_TIMEOUT: 419,
  MISDIRECTED_REQUEST: 421,
  UNPROCESSABLE_CONTENT: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  TOO_EARLY: 425,
  UPGRADE_REQUIRED: 426,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  VARIANT_ALSO_NEGOTIATES: 506,
  INSUFFICIENT_STORAGE: 507,
  LOOP_DETECTED: 508,
  NOT_EXTENDED: 510,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
};
